export default window.__litium.constants;

export const baseDateFormat = 'yyyy-MM-dd';

export const ViewMode = {
  List: 'list',
  Edit: 'edit',
  Detail: 'detail',
};

export const PaginationOptions = {
  PageSize: 5, // Number of items per page
  DisplayedEntries: 4, // Specifies how many links to show excluding possible EdgeEntries
  EdgeEntries: 2, // Specifies how many links from beginning and end to show ex. 1 2 3 ... 10 20 30 ... 97 98 99 where '1 2 3' and '97 98 99' are edge entries
};

export const ShippingIntegrationType = {
  Inline: 'Inline',
  DeliveryCheckout: 'DeliveryCheckout',
  PaymentCheckout: 'PaymentCheckout',
};

export const PaymentIntegrationType = {
  IframeCheckout: 'IframeCheckout',
  PaymentWidgets: 'PaymentWidgets',
  DirectPayment: 'DirectPayment',
};

export const ADDRESS_RECEIVE = 'ADDRESS_RECEIVE';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
export const ADDRESS_CHANGE_MODE = 'ADDRESS_CHANGE_MODE';

export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_LOAD = 'CART_LOAD';
export const CART_HIDE = 'CART_HIDE';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS = 'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION = 'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_CUSTOMER_INFO = 'CHECKOUT_SET_CUSTOMER_INFO';
export const CHECKOUT_SET_CAMPAIGN_CODE = 'CHECKOUT_SET_CAMPAIGN_CODE';
export const CHECKOUT_SET_SELECTED_CERTIFICATE = 'CHECKOUT_SET_SELECTED_CERTIFICATE';
export const CHECKOUT_SET_DELIVERY_CONTACT_PERSON = 'CHECKOUT_SET_DELIVERY_CONTACT_PERSON';
export const CHECKOUT_SET_SELECTED_DELIVERY_CONTACT_PERSON_PHONE = 'CHECKOUT_SET_SELECTED_DELIVERY_CONTACT_PERSON_PHONE';
export const CHECKOUT_SET_ORDER_MARKING = 'CHECKOUT_SET_ORDER_MARKING';
export const CHECKOUT_SET_CUSTOM_NOTE = 'CHECKOUT_SET_CUSTOM_NOTE';
export const CHECKOUT_SET_PICKING_INSTRUCTIONS = 'CHECKOUT_SET_PICKING_INSTRUCTIONS';
export const CHECKOUT_SET_PACKING_INSTRUCTIONS = 'CHECKOUT_SET_PACKING_INSTRUCTIONS';
export const CHECKOUT_SET_TRANSPORTATION_INSTRUCTIONS = 'CHECKOUT_SET_TRANSPORTATION_INSTRUCTIONS';
export const CHECKOUT_SET_SELECTED_SALES_REP = 'CHECKOUT_SET_SELECTED_SALES_REP';
export const CHECKOUT_SET_IS_VALID_FORM = 'CHECKOUT_SET_IS_VALID_FORM';
export const CHECKOUT_SAVE_CART_ON_PURCHASE = 'CHECKOUT_SAVE_CART_ON_PURCHASE';

export const HTTP_ERROR = 'HTTP_ERROR';
export const SAVED_CART_LOAD_ERROR = 'SAVED_CART_LOAD_ERROR';
export const SAVED_CART_LIST_RECEIVE = 'SAVED_CART_LIST_RECEIVE';
export const SAVED_CART_OPEN = 'SAVED_CART_OPEN';
export const SAVED_CART_CLOSE = 'SAVED_CART_CLOSE';
export const SAVED_CART_PRODUCT_SELECTION = 'SAVED_CART_PRODUCT_SELECTION';
export const SAVED_CART_PRODUCT_DESELECTION = 'SAVED_CART_PRODUCT_DESELECTION';

export const UPDATE_CART_ROW_STATUS = 'UPDATE_CART_ROW_STATUS';
export const UPDATE_CART_ROW_INIT_STATUS = 'UPDATE_CART_ROW_INIT_STATUS';
export const SAVED_CART_LIST_ADD_TO_CART_CLEAR = 'SAVED_CART_LIST_ADD_TO_CART_CLEAR';
export const DELETE_CART = 'DELETE_CART';
export const UPDATE_CART_NAME = 'UPDATE_CART_NAME';

export const UPDATE_ORGANIZATION_USER = 'UPDATE_ORGANIZATION_USER';
export const CHECKOUT_SET_ORGANIZATION_USER = 'CHECKOUT_SET_ORGANIZATION_USER';

export const FACETED_SEARCH_QUERY = 'FACETED_SEARCH_QUERY';
export const FACETED_SEARCH_RECEIVE = 'FACETED_SEARCH_RECEIVE';
export const FACETED_SEARCH_ERROR = 'FACETED_SEARCH_ERROR';
export const FACETED_SEARCH_TOGGLE_VALUE = 'FACETED_SEARCH_TOGGLE_VALUE';
export const FACETED_SEARCH_TOGGLE_COMPACT = 'FACETED_SEARCH_TOGGLE_COMPACT';
export const PRODUCT_VIEW_CACHED = 'PRODUCT_VIEW_CACHED';

export const LIGHTBOX_IMAGES_SET_CURRENT_IMAGE = 'LIGHTBOX_IMAGES_SET_CURRENT_IMAGE';
export const LIGHTBOX_IMAGES_SHOW = 'LIGHTBOX_IMAGES_SHOW';

export const NAVIGATION_LOAD_ERROR = 'NAVIGATION_LOAD_ERROR';
export const NAVIGATION_RECEIVE = 'NAVIGATION_RECEIVE';

export const PERSON_RECEIVE = 'PERSON_RECEIVE';
export const PERSON_ERROR = 'PERSON_ERROR';
export const PERSON_CHANGE_MODE = 'PERSON_CHANGE_MODE';

export const QUICK_SEARCH_QUERY = 'QUICK_SEARCH_QUERY';
export const QUICK_SEARCH_RECEIVE = 'QUICK_SEARCH_RECEIVE';
export const QUICK_SEARCH_ERROR = 'QUICK_SEARCH_ERROR';

export const ORGANIZATIONS_GET = 'ORGANIZATIONS_GET';
export const SET_MODAL_SHOW = 'SET_MODAL_SHOW';
export const SET_MODAL_SELECTED_ORG_ID = 'SET_MODAL_SELECTED_ORG_ID';
export const SET_MODAL_SEARCH_VALUE = 'SET_MODAL_SEARCH_VALUE';

export const ORDER_HISTORY_DETAIL_PRODUCT_SELECTION = 'ORDER_HISTORY_DETAIL_PRODUCT_SELECTION';
export const ORDER_HISTORY_DETAIL_PRODUCT_DESELECTION = 'ORDER_HISTORY_DETAIL_PRODUCT_DESELECTION';
export const ORDER_HISTORY_DETAIL_SET_ADD_TO_CART_LOADING = 'ORDER_HISTORY_DETAIL_SET_ADD_TO_CART_LOADING';
export const ORDER_HISTORY_DETAIL_LOAD_ERROR="ORDER_HISTORY_DETAIL_LOAD_ERROR";

export const CHECKOUT_SET_SHIPPING_OPTION="CHECKOUT_SET_SHIPPING_OPTION";
export const CHECKOUT_SET_SHIPMENT_WIDGET="CHECKOUT_SET_SHIPMENT_WIDGET";
